import { Column, Entity } from 'typeorm'
import { UserModifiableEntity } from '../entity'
import { CustomerEventType } from './enums'

@Entity()
export class CustomerEvent extends UserModifiableEntity<CustomerEvent> {
	@Column({
		type: 'enum',
		enum: CustomerEventType,
		nullable: false,
	})
	type: CustomerEventType

	@Column({
		type: 'uuid',
		nullable: true,
	})
	orderId?: string
}
